import axios from "axios";
import qs from "qs";
import {
    v4 as uuidv4
} from 'uuid';
const initialState = {
	supportTicket: {
	},
	supportTickets: [],
	supportTicketsCount: 0,
	unreadTickets: 0,
    queryObject: {
        offset: 0,
		limit: 5,
		type: ""
    }
};

export const state = { ...initialState };

export const actions = {
	async loadInvestorSupportTickets(context) {
		return axios.get("/api/support/tickets", {params: context.state.queryObject}).then(function(response){
			console.log(response.data)
			context.commit("setSupportTickets",response.data.supportTickets);
			context.commit("setSupportTicketsCount",response.data.supportTicketsCount);
		})
	},

	async loadInvestorSupportTicket(context, id) {
		return axios.get("/api/support/ticket", {params:{id:id}}).then(function(response){
			console.log(response)
			context.commit("setSupportTicket",response.data);
		})
	},

	async createSupportTicket(context, ticket) {
		return axios.post("/api/support/ticket", ticket).then(function(response){
			console.log(response.data)
		})
	},

	async loadInvestorUnreadTickets(context) {
		return axios.get("/api/support/unread/tickets").then(function(response){
			context.commit("setUnreadTickets",response.data.unreadTickets);
		})
	},

	updateQuery(context,data){
        context.commit("setQuery",data);
    },
};

export const mutations = {
	setSupportTickets(state,data) {
		state.supportTickets = data;
	},
	setSupportTicketsCount(state,data) {
		state.supportTicketsCount = data;
	},
	setUnreadTickets(state,number){
		state.unreadTickets = number;
	},
	setSupportTicket(state,data) {
		state.supportTicket = data;
	},
	setQuery(state,obj){
        state.queryObject=obj;
    },
};

const getters = {
	supportTicket(state){
		return state.supportTicket;
	},
	supportTickets(state){
		return state.supportTickets;
	},
	supportTicketsCount(state){
		return state.supportTicketsCount;
	},
	unreadTickets(state){
		return state.unreadTickets;
	}
};

export default {
    state,
    actions,
    mutations,
    getters
};
  